import React, { useState, useEffect } from 'react';
import './News.css'; 
import { 
  collection, 
  addDoc, 
  getDocs, 
  deleteDoc, 
  doc, 
  updateDoc,
  serverTimestamp 
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase/firebase-config';

function News() {

  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentId, setCurrentId] = useState(null);

  const [formData, setFormData] = useState({
    title: '',
    content: '',
    seoDescription: '',
    image: null, 
    imageUrl: ''
  });

  const newsCollectionRef = collection(db, "news");

  const getNews = async () => {
    setLoading(true);
    try {
      const data = await getDocs(newsCollectionRef);
      const filteredData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      filteredData.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
      setNewsList(filteredData);
    } catch (err) {
      console.error("Hata:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNews();
  }, []);

  const uploadImage = async (file) => {
    if (!file) return null;
    const fileRef = ref(storage, `news/${file.name + Date.now()}`);
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let url = formData.imageUrl;

      if (formData.image) {
        url = await uploadImage(formData.image);
      }

      const payload = {
        title: formData.title,
        content: formData.content,
        seoDescription: formData.seoDescription || "",
        imageUrl: url,
        updatedAt: serverTimestamp(),
      };

      if (editMode) {

        const newsDoc = doc(db, "news", currentId);
        await updateDoc(newsDoc, payload);
        alert("Haber güncellendi!");

      } else {

        await addDoc(newsCollectionRef, {
          ...payload,
          createdAt: serverTimestamp(),
        });

        alert("Haber eklendi!");
      }

      resetForm();
      getNews();

    } catch (error) {
      console.error("İşlem hatası:", error);
      alert("Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bu haberi silmek istediğine emin misin?")) {
      const newsDoc = doc(db, "news", id);
      await deleteDoc(newsDoc);
      getNews();
    }
  };

  const handleEdit = (newsItem) => {

    setEditMode(true);
    setCurrentId(newsItem.id);

    setFormData({
      title: newsItem.title || '',
      content: newsItem.content || '',
      seoDescription: newsItem.seoDescription || '',
      image: null,
      imageUrl: newsItem.imageUrl || ''
    });

    window.scrollTo(0, 0);
  };

  const resetForm = () => {

    setFormData({
      title: '',
      content: '',
      seoDescription: '',
      image: null,
      imageUrl: ''
    });

    setEditMode(false);
    setCurrentId(null);

    const fileInput = document.getElementById('fileInput');
    if (fileInput) fileInput.value = "";
  };

  return (
    <div className="news-container">

      <header className="news-header">
        <h2>Haber Yönetimi</h2>
        <p>Arzu Hanım'ın web sitesindeki haberleri buradan yönetebilirsiniz.</p>
      </header>

      <div className="news-form-card">
        <h3>{editMode ? 'Haberi Düzenle' : 'Yeni Haber Ekle'}</h3>

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label>Haber Başlığı</label>
            <input
              type="text"
              placeholder="Örn: Yeni Ofisimiz Açıldı"
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
              required
            />
          </div>

          {/* ✅ SEO DESCRIPTION */}
          <div className="form-group">
            <label>SEO Açıklaması (Meta Description)</label>
            <textarea
              rows="3"
              maxLength={160}
              placeholder="Google sonuçlarında görünecek kısa açıklama (max 160 karakter)"
              value={formData.seoDescription}
              onChange={(e) =>
                setFormData({ ...formData, seoDescription: e.target.value })
              }
            />
            <small>
              {formData.seoDescription.length}/160
            </small>
          </div>

          <div className="form-group">
            <label>Görsel {editMode && "(Değiştirmek istemiyorsan boş bırak)"}</label>
            <input
              id="fileInput"
              type="file"
              accept="image/*"
              onChange={(e) =>
                setFormData({ ...formData, image: e.target.files[0] })
              }
              required={!editMode}
            />

            {formData.imageUrl && !formData.image && (
              <div className="current-img-preview">
                <small>Mevcut Görsel:</small>
                <img src={formData.imageUrl} alt="Mevcut" width="60" />
              </div>
            )}
          </div>

          <div className="form-group">
            <label>İçerik</label>
            <textarea
              rows="5"
              placeholder="Haber detaylarını buraya girin..."
              value={formData.content}
              onChange={(e) =>
                setFormData({ ...formData, content: e.target.value })
              }
              required
            ></textarea>
          </div>

          <div className="form-actions">
            {editMode && (
              <button
                type="button"
                className="btn-cancel"
                onClick={resetForm}
              >
                Vazgeç
              </button>
            )}

            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
            >
              {loading ? 'İşleniyor...' : (editMode ? 'Güncelle' : 'Yayınla')}
            </button>
          </div>

        </form>
      </div>

      <hr className="divider" />

      <div className="news-list">
        <h3>Mevcut Haberler ({newsList.length})</h3>

        {newsList.map((item) => (
          <div key={item.id} className="news-item">

            <div className="news-img">
              <img src={item.imageUrl} alt={item.title} />
            </div>

            <div className="news-info">
              <h4>{item.title}</h4>

              <small className="date">
                {item.createdAt
                  ? new Date(item.createdAt.seconds * 1000)
                      .toLocaleDateString('tr-TR')
                  : 'Tarih yok'}
              </small>

              <p>
                {item.seoDescription
                  ? item.seoDescription
                  : item.content?.substring(0, 100) + '...'}
              </p>
            </div>

            <div className="news-actions">
              <button
                onClick={() => handleEdit(item)}
                className="btn-edit"
              >
                Düzenle
              </button>

              <button
                onClick={() => handleDelete(item.id)}
                className="btn-delete"
              >
                Sil
              </button>
            </div>

          </div>
        ))}
      </div>

    </div>
  );
}

export default News;